import { getSessionAuthentication, baseUrl } from '../common/Api';

interface FetchOptions {
    method: string;
    headers: Record<string, string>;
    body?: string;
}

function getHeaders(): Record<string, string> {
    const auth = getSessionAuthentication();
    return {
        'Content-Type': 'application/json',
        'Authorization': auth.token,
        'x-cleverapps-tenant': auth.tenantStringIdentifier,
    };
}

async function legacyFetch<T>(path: string, options?: Partial<FetchOptions>): Promise<T> {
    const response = await fetch(baseUrl + path, {
        method: options?.method ?? 'GET',
        headers: getHeaders(),
        body: options?.body,
    });
    if (!response.ok) {
        const text = await response.text();
        let message = `API error: ${response.status} ${response.statusText}`;
        try {
            const parsed = JSON.parse(text);
            if (parsed?.message) message = parsed.message;
        } catch { /* ignore */ }
        throw new Error(message);
    }
    const text = await response.text();
    return text ? JSON.parse(text) : null;
}

export interface Intrastat {
    id: number;
    code: string;
    internalDescription?: string;
    externalCode1?: string;
    externalCode2?: string;
    externalCode3?: string;
    externalDescription1?: string;
    externalDescription2?: string;
    externalDescription3?: string;
}

export async function getIntrastat(id: number): Promise<Intrastat> {
    return legacyFetch<Intrastat>(`intrastats/${id}`);
}

// Backend uses a single POST endpoint for both create and update.
export async function saveIntrastat(i: Intrastat): Promise<Intrastat> {
    return legacyFetch<Intrastat>('intrastats', {
        method: 'POST',
        body: JSON.stringify(i),
    });
}

export async function deleteIntrastat(id: number): Promise<void> {
    await legacyFetch<void>(`intrastats/${id}`, { method: 'DELETE' });
}
